import React from 'react';

const UpdateCourse = ({ updateCourse,onClose, memberships, imageUrl, handleCourseUpdateSubmit, handleCourseChange, loading }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold text-gray-800">Edit Course</h2>
            <button
              onClick={onClose} // বা আপনার ক্লোজ হ্যান্ডলার
              className="text-gray-500 hover:text-gray-700 text-2xl"
            >
              &times;
            </button>
          </div>

          <form onSubmit={handleCourseUpdateSubmit} className="space-y-4">
            {/* Grid Layout for Input Fields */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* Sort Order Id */}
              <div className="mb-4">
                <label className="block text-gray-700">Sort Order Id</label>
                <input
                  type="text"
                  name="sort_order"
                  value={updateCourse.sort_order}
                  onChange={handleCourseChange}
                  className="border w-full p-2"
                  placeholder="Enter Sort Order"
                />
              </div>
              {/* Name */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Course Name*</label>
                <input
                  type="text"
                  name="name"
                  value={updateCourse.name}
                  onChange={handleCourseChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>

              {/* Instructor */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Instructor*</label>
                <input
                  type="text"
                  name="instructor"
                  value={updateCourse.instructor}
                  onChange={handleCourseChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>

              {/* Duration */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Duration</label>
                <input
                  type="text"
                  name="duration"
                  value={updateCourse.duration}
                  onChange={handleCourseChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>

              {/* Membership Type */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Membership Type*</label>
                <select
                  name="membership_type"
                  value={updateCourse.membership_type}
                  onChange={handleCourseChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                >
                  <option value="">Select Membership</option>
                  {memberships.map((membership) => (
                    <option key={membership.id} value={membership.id}>
                      {membership.membership_type}
                    </option>
                  ))}
                </select>
              </div>

              {/* Price */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Price*</label>
                <input
                  type="number"
                  name="price"
                  value={updateCourse.price}
                  onChange={handleCourseChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>

              {/* Offer Price */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Offer Price</label>
                <input
                  type="number"
                  name="offer_price"
                  value={updateCourse.offer_price}
                  onChange={handleCourseChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>

            {/* Description */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
              <textarea
                name="desc"
                value={updateCourse.desc}
                onChange={handleCourseChange}
                rows="3"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              ></textarea>
            </div>

            {/* Curriculum */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Curriculum</label>
              <textarea
                name="curriculum"
                value={updateCourse.curriculum}
                onChange={handleCourseChange}
                rows="3"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              ></textarea>
            </div>

            {/* Image Upload */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Course Image</label>
              {updateCourse.image && (
                <div className="mb-2">
                  <img
                    src={`${imageUrl}/${updateCourse.image}`}
                    alt="Course"
                    className="h-32 w-auto object-cover rounded-md border"
                  />
                </div>
              )}
              <div className="flex items-center">
                <label className="flex flex-col items-center px-4 py-2 bg-white text-blue-500 rounded-lg border border-blue-500 cursor-pointer hover:bg-blue-50">
                  <span className="text-sm font-medium">Choose File</span>
                  <input
                    type="file"
                    name="image"
                    onChange={handleCourseChange}
                    className="hidden"
                    accept="image/*"
                  />
                </label>
                <span className="ml-2 text-sm text-gray-500">
                  {updateCourse.image instanceof File ? updateCourse.image.name : "No file chosen"}
                </span>
              </div>
            </div>

            {/* Submit Button */}
            <div className="pt-4">
              <button
                type="submit"
                disabled={loading}
                className={`w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 ${loading ? 'opacity-70 cursor-not-allowed' : ''}`}
              >
                {loading ? (
                  <span className="flex items-center justify-center">
                    <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Updating...
                  </span>
                ) : 'Update Course'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default UpdateCourse;